/**
 * Registers the administrator roster at `/admins`, order 60.
 */

import { createElement } from 'react';
import { Users } from 'lucide-react';

import { defineCatalogue } from '../../i18n';
import type { OpsRouteBundle } from '../routes/contract';
import { OpsShell } from '../shell/OpsShell';
import { Admins } from './Admins';

const catalogue = defineCatalogue({ navLabel: 'Administradores' }, { navLabel: 'Administrators' });

export const bundle: OpsRouteBundle = {
  order: 60,
  routes: [
    {
      path: '/admins',
      element: createElement(OpsShell, null, createElement(Admins)),
      kind: 'data',
    },
  ],
  // Figma 153:342: the sidebar row's own icon is "users".
  nav: [{ path: '/admins', label: () => catalogue.t('navLabel'), icon: Users, kind: 'data' }],
};
